import { render, staticRenderFns } from "./ComGoodsLimit.vue?vue&type=template&id=6fb7fdb3&scoped=true&"
import script from "./ComGoodsLimit.vue?vue&type=script&lang=js&"
export * from "./ComGoodsLimit.vue?vue&type=script&lang=js&"
import style0 from "./ComGoodsLimit.vue?vue&type=style&index=0&id=6fb7fdb3&prod&lang=css&"
import style1 from "./ComGoodsLimit.vue?vue&type=style&index=1&id=6fb7fdb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb7fdb3",
  null
  
)

export default component.exports